<div class="skill-card">
  <a href="{{urlSkill}}" target="_blank">
    <img [src]="logosPath+skillSVG" alt="{{skillName}}">
  </a>
</div>
